import IconButton from 'components/IconButton';
import NoRecordFound from 'components/NoRecordFound/NoRecordFound';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import React from 'react';
import { Button } from 'reactstrap';
import { companyIdAtom } from 'views/state';

import { getVendorSubscription, subscribeVendor, unsubscribe } from './helper';
import {
  selectedVendorAtom,
  vendorSubscriptionsAtom,
  refreshSubscriptionsAtom,
  vendorsDataAtom,
} from '../state';

const VendorsListing: React.FC = () => {
  const vendorsData = useAtomValue(vendorsDataAtom);
  const vendors = vendorsData?.results;
  const vendorSubscriptions = useAtomValue(vendorSubscriptionsAtom);
  const [selectedVendor, setSelectedVendor] = useAtom(selectedVendorAtom);
  const setRefreshSubscription = useSetAtom(refreshSubscriptionsAtom);
  const companyId = useAtomValue(companyIdAtom);

  const handleSubscribe = (vendor) => {
    subscribeVendor(vendor.name, companyId)
      .then((result) => {
        if (result === true) {
          showSuccessToast('Subscription Successful');
          setRefreshSubscription(Math.random()); // Reset atom only if subscription is successful
        } else {
          showFailureToast('Failed to subscribe');
        }
      })
      .catch((_error) => {
        showFailureToast('Failed to subscribe');
      });
  };

  const handleUnsubscribe = (id) => {
    unsubscribe(id, companyId)
      .then((result) => {
        if (result === true) {
          showSuccessToast('Successfully unsubscribed');
          setRefreshSubscription(Math.random()); // Reset atom only if operation is successful
        } else {
          showFailureToast('Failed to unsubscribe');
        }
      })
      .catch((_error) => {
        showFailureToast('Failed to unsubscribe');
      });
  };

  return (
    <>
      {vendors && vendors?.length > 0 ? (
        vendors.map((vendor) => {
          let subscription = getVendorSubscription(
            vendorSubscriptions,
            vendor.name,
          );

          return (
            <tr
              key={vendor.name}
              className={
                selectedVendor === vendor.name
                  ? 'dynamic-select-tr active'
                  : 'dynamic-select-tr'
              }
            >
              <td>
                <Button
                  color="primary"
                  outline={true}
                  size="sm"
                  title="Click to select this vendor"
                  onClick={() => setSelectedVendor(vendor.name)}
                >
                  {vendor.name}
                </Button>
              </td>
              <td className="text-right">
                {subscription !== undefined ? (
                  <IconButton
                    id={`sv-${vendor.id}`}
                    iconClass="fa fa-bell-slash"
                    size="sm"
                    tooltip="Unsubscribe"
                    onClick={() => handleUnsubscribe(subscription?.id)}
                  />
                ) : (
                  <IconButton
                    id={`sv-${vendor.id}`}
                    iconClass="fa fa-bell"
                    size="sm"
                    tooltip="Subscribe"
                    onClick={() => handleSubscribe(vendor)}
                  />
                )}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={3}>
            <NoRecordFound />
          </td>
        </tr>
      )}
    </>
  );
};

export default VendorsListing;
